﻿import Artcloud from '../../artcloud.js';

const AcceptedPayment = {
    None: { value: 0 },
    Card: { value: 1, label: 'Credit Card' },
    Ach: { value: 2, label: 'ACH' },
    Affirm: { value: 4, label: 'Affirm' },

    options: () => [AcceptedPayment.Card, AcceptedPayment.Ach, AcceptedPayment.Affirm]
};

const Account = {
    Gallery: 1,
    Artist: 2,

    display: (type) => {
        switch (type) {
            case Account.Artist:
                return 'Artist';
            case Account.Gallery:
                return 'Gallery';
        }
    },

    hasType: (accountTypes, type) => {
        return accountTypes & type
    }
};

const ActiveStatus = {
    All: { value: 1, label: 'All' },
    Active: { value: 2, label: 'Active' },
    Inactive: { value: 3, label: 'Inactive' },
    Available: { value: 4, label: 'Available' },
    Sold: { value: 5, label: 'Sold' },

    options: () => [ActiveStatus.All, ActiveStatus.Active, ActiveStatus.Inactive],

    optionsInventory: () => [
        ActiveStatus.All,
        ActiveStatus.Active,
        ActiveStatus.Inactive,
        ActiveStatus.Available,
        ActiveStatus.Sold
    ]
};

const Activity = {
    Notifications: { value: 0, label: 'All' },
    Messages: { value: 3, label: 'Messages' },
    Activities: { value: 4, label: 'Activity' },

    ReleaseNotes: { value: 5, label: 'Release Notes' },
    Global: { value: 6, label: 'Global Notifications' }
};

const ActivityFilter = {
    Email: { value: 0, label: 'Email' },
    ToDo: { value: 1, label: 'To-Do' },
    Note: { value: 2, label: 'Note' },
    Status: { value: 3, label: 'Status' },
    Invoice: { value: 4, label: 'Invoice' },
    Offer: { value: 5, label: 'Offer' },
    Opportunity: { value: 6, label: 'Opportunity' },
    Campaign: { value: 7, label: 'Campaign' },
    Hold: { value: 8, label: 'Hold' }
};

const ActivityStatus = {
    Read: 0,
    Unread: 1
};

const Address = {
    Billing: { value: 0, label: 'Billing' },
    Shipping: { value: 1, label: 'Shipping' },

    options: () => [Address.Billing, Address.Shipping]
};

const AdminEmail = {
    Website: 0,
    Data: 1
};

const AdminUser = [
    { label: 'All' },
    { value: 0, label: 'Gallery' },
    { value: 1, label: 'Artist' },
    { value: 2, label: 'Collector' }
];

const AnalyticsDateRange = {
    Today: { value: 1, label: 'Today' },
    Yesterday: { value: 2, label: 'Yesterday' },
    WeekToDate: { value: 3, label: 'Week to Date' },
    LastWeek: { value: 4, label: 'Last Week' },
    MonthToDate: { value: 5, label: 'Month to Date' },
    LastMonth: { value: 6, label: 'Last Month' },
    QuarterToDate: { value: 7, label: 'Quarter to Date' },
    LastQuarter: { value: 8, label: 'Last Quarter' },
    YearToDate: { value: 9, label: 'Year to Date' },
    LastYear: { value: 10, label: 'Last Year' },
    Custom: { value: 11, label: 'Custom' },

    options: () => [
        AnalyticsDateRange.Today,
        AnalyticsDateRange.Yesterday,
        AnalyticsDateRange.WeekToDate,
        AnalyticsDateRange.LastWeek,
        AnalyticsDateRange.MonthToDate,
        AnalyticsDateRange.LastMonth,
        AnalyticsDateRange.QuarterToDate,
        AnalyticsDateRange.LastQuarter,
        AnalyticsDateRange.YearToDate,
        AnalyticsDateRange.LastYear,
        AnalyticsDateRange.Custom
    ]
};

const AnalyticsSource = {
    Marketplace: 0,
    Website: 1
};

const Audience = {
    Active: { label: 'Active', value: 0 },
    Static: { label: 'Static', value: 1 },
    Scheduled: { value: 2 }
};

const Batch = {
    Inventory: { value: '0', label: 'Inventory' },
    Artist: { value: '1', label: 'Artist' },
    Contact: { value: '2', label: 'Contact' },
    Opportunity: { value: '4', label: 'Opportunity' }
};

const BatchStatus = {
    Complete: 0,
    Incomplete: 1
};

const BillingPermission = {
    Action: {
        CreateClient: "CreateClient",
        CreateInventory: "CreateInventory",
        CreateInvoice: "CreateInvoice",
        CreateLocation: "CreateLocation",
        CreateStaff: "CreateStaff",
        OptArtistWebsite: "OptArtistWebsite",
        OptInventoryWebsite: "OptInventoryWebsite",
        SendCampaign: "SendCampaign"
    },
    Reason: {
        InvalidPermission: 0,
        NoSubscription: 1,
        SubscriptionChangeRequired: 2,
        AdditionalCostIncurred: 3
    }
};

const Campaign = {
    Newsletter: 0,
    Arrivals: 1,
    Template: 2
};

const CampaignAudienceRetarget = {
    Unopened: { value: 0, label: 'Unopened' },
    Opened: { value: 1, label: 'Opened' },
    Clicked: { value: 2, label: 'Clicked' }
};

const CampaignResults = {
    Delivered: { value: 0, label: 'Delivered', title: "Delivere rate" },
    Opened: { value: 1, label: 'Opened', title: "Open rate" },
    Clicked: { value: 2, label: 'Clicked', title: "Click rate" },
    Bounced: { value: 3, label: 'Bounced', title: "Bounce rate" },
    Unsubscribed: { value: 4, label: 'Unsubscribed', title: "Unsubscribe rate" }
};

const CollateralExport = {
    Arrivals: 'arrivals',
    ArtistBio: 'bios',
    CertificateOfAuthenticity: 'certificates',
    CertificateOfAuthenticityList: 'certificatesList',
    Consignment: 'consignments',
    ConsignmentReport: 'consignmentReport',
    Invoice: 'invoices',
    Mosaic: 'mosaics',
    MosaicItems: 'mosaicItems',
    Offer: 'offers',
    Pricelist: 'pricelists',
    PricelistItems: 'pricelistItems',
    PurchaseOrder: 'purchaseOrders',
    Tearsheet: 'tearsheets',
    TearsheetList: 'tearsheetList',
    WallTag: 'walltags',
    WallTagItems: 'walltagItems'
};

const Composition = {
    Type: {
        Header: 0,
        Footer: 1,
        Home: 2,
        InventoryProfile: 3,
        ArtistProfile: 4,
        ExhibitionProfile: 5,
        Contact: 6,
        InventoryPage: 7,
        ArtistsPage: 8,
        ExhibitionsPage: 9,
        Typography: 10,
        Colors: 11,
        Cell: {
            ArtistGrid: 12,
            Blog: 13,
            ExhibitionGrid: 14,
            ExhibitionParallax: 15,
            InventoryGrid: 16,
            InventoryWaterfall: 17,
            RecentlyViewed: 18
        },

        display: (value) => {
            switch (value) {
                case Composition.Type.ArtistProfile:
                    return 'Artist Profile';
                case Composition.Type.ArtistsPage:
                    return 'Artists Page';
                case Composition.Type.Cell.ArtistGrid:
                    return 'Artist Grid Cell';
                case Composition.Type.Cell.Blog:
                    return 'Blog Cell';
                case Composition.Type.Cell.ExhibitionGrid:
                    return 'Exhibition Grid Cell';
                case Composition.Type.Cell.ExhibitionParallax:
                    return 'Exhibition Parallax Cell';
                case Composition.Type.Cell.InventoryGrid:
                    return 'Inventory Grid Cell';
                case Composition.Type.Cell.InventoryWaterfall:
                    return 'Inventory Waterfall Cell';
                case Composition.Type.Cell.RecentlyViewed:
                    return 'Recently Viewed Cell';
                case Composition.Type.Colors:
                    return 'Colors';
                case Composition.Type.Contact:
                    return 'Contact Page';
                case Composition.Type.Footer:
                    return 'Footer';
                case Composition.Type.Header:
                    return 'Header';
                case Composition.Type.Home:
                    return 'Home Page';
                case Composition.Type.ExhibitionProfile:
                    return 'Exhibition Detail';
                case Composition.Type.ExhibitionsPage:
                    return 'Exhibitions Page';
                case Composition.Type.InventoryProfile:
                    return 'Inventory Detail';
                case Composition.Type.InventoryPage:
                    return 'Inventory Page';
                case Composition.Type.Typography:
                    return 'Typography';
            }
        },
        options: () => [
            Composition.Type.ArtistProfile,
            Composition.Type.ArtistsPage,
            Composition.Type.Colors,
            Composition.Type.Contact,
            Composition.Type.ExhibitionProfile,
            Composition.Type.ExhibitionsPage,
            Composition.Type.Footer,
            Composition.Type.Header,
            Composition.Type.Home,
            Composition.Type.InventoryProfile,
            Composition.Type.InventoryPage,
            Composition.Type.Typography,
            Composition.Type.Cell.ArtistGrid,
            Composition.Type.Cell.Blog,
            Composition.Type.Cell.ExhibitionGrid,
            Composition.Type.Cell.ExhibitionParallax,
            Composition.Type.Cell.InventoryGrid,
            Composition.Type.Cell.InventoryWaterfall,
            Composition.Type.Cell.RecentlyViewed,
        ].map(value => ({ value, label: Composition.Type.display(value) }))
    }
};

const Consignment = {
    Inbound: { value: 0, label: 'Consignment - Inbound' },
    ThirdParty: { value: 1, label: 'Third Party Consignment' },
    InventoryReturn: { value: 2, label: 'Inventory Return' },
    Gallery: { value: 3, label: 'Gallery Consignment' },

    display: (value) => {
        switch (value) {
            case Consignment.Inbound.value:
                return 'Inbound Consignment';
            case Consignment.ThirdParty.value:
                return Consignment.ThirdParty.label;
            case Consignment.InventoryReturn.value:
                return Consignment.InventoryReturn.label;
            case Consignment.Gallery.value:
                return Consignment.Gallery.label;
        }
    },

    listActionType: (value) => {
        switch (value) {
            case Consignment.Inbound.value:
                return 1;
            case Consignment.ThirdParty.value:
                return 2;
            case Consignment.InventoryReturn.value:
                return 3;
            case Consignment.Gallery.value:
                return 4;
        }
    },

    options: () => [Consignment.Inbound, Consignment.ThirdParty, Consignment.InventoryReturn],

    optionsArtist: () => [Consignment.Gallery, Consignment.InventoryReturn]
};

const SENDABLE_TYPES = new Set([
    Consignment.Inbound.value,
    Consignment.ThirdParty.value,
    Consignment.Gallery.value
]);

const isSendable = (typeValue) => SENDABLE_TYPES.has(typeValue);

const ConsignmentCost = {
    Amount: { value: 1, label: 'Amount' },
    Percentage: { value: 2, label: 'Percentage' },

    options: () => [ConsignmentCost.Amount, ConsignmentCost.Percentage],

    optionsArtist: () => [ConsignmentCost.Percentage, ConsignmentCost.Amount]
};

const Consigner = {
    Contact: { value: 0, param: 'contactconsigner' },
    Artist: { value: 1, param: 'artistconsigner' }
};

const Currency = {
    ExchangeRates: [
        'AED', 'AFN', 'ALL', 'AMD', 'ANG', 'AOA', 'ARS', 'AUD', 'AWG', 'AZN',
        'BAM', 'BBD', 'BDT', 'BGN', 'BHD', 'BIF', 'BMD', 'BND', 'BOB', 'BOV',
        'BRL', 'BSD', 'BTN', 'BWP', 'BYN', 'BZD', 'CAD', 'CDF', 'CHE', 'CHF',
        'CHW', 'CLF', 'CLP', 'CNY', 'COP', 'COU', 'CRC', 'CUP', 'CVE', 'CZK',
        'DJF', 'DKK', 'DOP', 'DZD', 'EGP', 'ERN', 'ETB', 'EUR', 'FJD', 'FKP',
        'GBP', 'GEL', 'GHS', 'GIP', 'GMD', 'GNF', 'GTQ', 'GYD', 'HKD', 'HNL',
        'HTG', 'HUF', 'IDR', 'ILS', 'INR', 'IQD', 'IRR', 'ISK', 'JMD', 'JOD',
        'JPY', 'KES', 'KGS', 'KHR', 'KMF', 'KPW', 'KRW', 'KWD', 'KYD', 'KZT',
        'LAK', 'LBP', 'LKR', 'LRD', 'LSL', 'LYD', 'MAD', 'MDL', 'MGA', 'MKD',
        'MMK', 'MNT', 'MOP', 'MRU', 'MUR', 'MVR', 'MWK', 'MXN', 'MXV', 'MYR',
        'MZN', 'NAD', 'NGN', 'NIO', 'NOK', 'NPR', 'NZD', 'OMR', 'PAB', 'PEN',
        'PGK', 'PHP', 'PKR', 'PLN', 'PYG', 'QAR', 'RON', 'RSD', 'RUB', 'RWF',
        'SAR', 'SBD', 'SCR', 'SDG', 'SEK', 'SGD', 'SHP', 'SLE', 'SOS', 'SRD',
        'SSP', 'STN', 'SVC', 'SYP', 'SZL', 'THB', 'TJS', 'TMT', 'TND', 'TOP',
        'TRY', 'TTD', 'TWD', 'TZS', 'UAH', 'UGX', 'USD', 'USN', 'UYI', 'UYU',
        'UYW', 'UZS', 'VED', 'VES', 'VND', 'VUV', 'WST', 'XAF', 'XAG', 'XAU',
        'XBA', 'XBB', 'XBC', 'XBD', 'XCD', 'XDR', 'XOF', 'XPD', 'XPF', 'XPT',
        'XSU', 'XTS', 'XUA', 'XXX', 'YER', 'ZAR', 'ZMW', 'ZWG'
    ],
    Rounding: {
        None: { value: 0, label: 'No Rounding' },
        Ones: { value: 1, label: 'Ones' },
        Tens: { value: 2, label: 'Tens' },
        Hundreds: { value: 3, label: 'Hundreds' },
        Thousands: { value: 4, label: 'Thousands' },
        TenThousands: { value: 5, label: 'Ten Thousands' },

        options: () => [
            Currency.Rounding.None,
            Currency.Rounding.Ones,
            Currency.Rounding.Tens,
            Currency.Rounding.Hundreds,
            Currency.Rounding.Thousands,
            Currency.Rounding.TenThousands
        ]
    }
};

const CurrencySymbolPlacement = {
    Before: { value: 1, label: 'Before' },
    After: { value: 2, label: 'After' }
};

const DateFormat = {
    MonthDayYear: { value: 0, label: 'MMDDYYYY' },
    DayMonthYear: { value: 1, label: 'DDMMYYYY' },

    options: () => [DateFormat.MonthDayYear, DateFormat.DayMonthYear],

    defaultFormatString: 'M/d/yyyy',
    formatStringForType: (type) => {
        switch (parseInt(type, 10)) {
            case DateFormat.MonthDayYear.value:
                return 'M/d/yyyy';
            case DateFormat.DayMonthYear.value:
                return 'd/MM/yyyy';
            default:
                return 'MM/dd/yyyy';
        }
    },
    // Mantine weekday index: 0 = Sunday, 1 = Monday.
    firstDayOfWeekForType: (type) => (parseInt(type, 10) === DateFormat.DayMonthYear.value ? 1 : 0)
};

const Discount = {
    Percentage: { value: 1, label: '%' },
    Currency: { value: 2, label: '$' },

    options: (session) => [
        Discount.Percentage,
        { value: Discount.Currency.value, label: session && session.Config && session.Config.CurrencySymbol || Discount.Currency.label }
    ]
};

const Edition = {
    Original: { value: 0, label: 'Original' },
    Limited: { value: 1, label: 'Limited' },
    Unlimited: { value: 2, label: 'Unlimited' },

    options: (includeOriginal) => {
        let options = [Edition.Limited, Edition.Unlimited];
        if (includeOriginal != false) {
            options.splice(0, 0, Edition.Original);
        }
        return options;
    }
};

const Email = {
    ArtistSignup: 'artistSignup',
    InquiryResponse: 'inquiry',
    InventoryInquiryResponse: 'inventoryInquiry',
    Offer: 'offer',
    PurchaseConfirmation: 'purchaseConfirmation',
    Subscribe: 'subscribe',

    display: (type) => {
        switch (type) {
            case Email.ArtistSignup:
                return "Artist Signup";
            case Email.InquiryResponse:
                return "Inquiry Response";
            case Email.InventoryInquiryResponse:
                return "Inventory Inquiry Response";
            case Email.Offer:
                return "Offer Response";
            case Email.PurchaseConfirmation:
                return "Purchase Confirmation";
            case Email.Subscribe:
                return "Subscription Confirmation";
        }
    },

    value: (type) => {
        switch (type) {
            case Email.InventoryInquiryResponse:
                return 0;
            case Email.InquiryResponse:
                return 1;
            case Email.PurchaseConfirmation:
                return 2;
            case Email.Subscribe:
                return 3;
            case Email.ArtistSignup:
                return 4;
            case Email.Offer:
                return 5;
        }
    }
};

const Export = {
    Download: 'Attachment',
    Print: 'Inline'
};

const ExportStatus = {
    Pending: { value: 0, label: 'Pending' },
    Completed: { value: 1, label: 'Completed' },
    Failed: { value: 2, label: 'Failed' }
};

const Gate = {
    Analytics: 'analytics',
    Artsy: 'artsy',
    Audiences: 'audiences',
    Billing: 'billing',
    Builder: {
        BlockConfig: 'builder_blockConfig',
        Blocks: 'builder_blocks',
        Filter: 'builder_filter',
        IncludeVirtualInstall: 'builder_includeVirtualInstall',
        ResourceLinking: 'builder_resourceLinking',
        Tabs: 'builder_tabs'
    },
    CampaignDomains: 'campaignDomains',
    Campaigns: 'campaigns',
    Contacts: 'clients',
    Collateral: 'collateral',
    EmailTemplates: 'emailTemplates',
    InventoryFinancials: 'inventoryFinancials',
    InventorySEO: 'inventorySEO',
    Invoices: 'invoices',
    LegacyPricing: 'legacyPricing',
    Marketplace: 'marketplace',
    MarketplaceAnalytics: 'marketplaceAnalytics',
    Messages: 'messages',
    Opportunities: 'opportunities',
    PrivateViews: 'privateViews',
    PurchaseOrders: 'purchaseOrders',
    SocialCatalogs: 'socialCatalogs',
    StripeExpress: 'stripeExpress',
    Todos: 'todos',
    Website: 'website',
    WebsiteAnalytics: 'websiteAnalytics',
    WebsiteDomain: 'websiteDomain',
    WebsitePassword: 'websitePassword',
    WebsiteRedirect: 'websiteRedirect'
};

const ImportStatus = {
    Pending: 0,
    Error: 1,
    Complete: 2
};

const Inventory = {
    Artwork: { value: 0, label: 'Artwork' },
    Merchandise: { value: 1, label: 'Merchandise' },
    MerchandiseAlt: { value: 2, label: 'Merchandise' },
    AdHoc: { value: 2 },
    Jewelry: { value: 5, label: 'Jewelry' },
    Furniture: { value: 6, label: 'Furniture' },
    Lighting: { value: 7, label: 'Lighting' },
    Decor: { value: 8, label: 'Decor' },

    display: (value) => {
        switch (value) {
            case Inventory.Merchandise.value:
                return Inventory.Merchandise.label;
            case Inventory.Jewelry.value:
                return Inventory.Jewelry.label;
            case Inventory.Furniture.value:
                return Inventory.Furniture.label;
            case Inventory.Lighting.value:
                return Inventory.Lighting.label;
            case Inventory.Decor.value:
                return Inventory.Decor.label;
            case Inventory.Artwork.value:
            default:
                return Inventory.Artwork.label;
        }
    },

    isNonEditionedType: (value, merchTypeValue) => {
        const _merchTypeValue = merchTypeValue != undefined ? merchTypeValue : Inventory.Merchandise.value
        switch (value) {
            case Inventory.Decor.value:
            case Inventory.Furniture.value:
            case Inventory.Jewelry.value:
            case Inventory.Lighting.value:
            case _merchTypeValue:
                return true;
            default:
                return false;
        }
    }
};

const InviteStage = {
    Uninvited: 0,
    Accepted: 1,
    Invited: 2
};

const Invoice = {
    Invoice: 0,
    Offer: 1,
    PurchaseOrder: 2
};

const InvoiceItem = {
    Inventory: { value: 0, label: 'Inventory' },
    TitleCatalog: { value: 1, label: 'Title Catalog' },
    Service: { value: 2, label: 'Service' },

    options: () => [InvoiceItem.Inventory, InvoiceItem.TitleCatalog, InvoiceItem.Service]
};

const InvoiceStatus = {
    Open: { value: 1, label: 'Open' },
    OnApproval: { value: 2, label: 'On Approval' },
    Closed: { value: 3, label: 'Closed' },
    Declined: { value: 4, label: 'Declined' },

    display: (value) => {
        switch (value) {
            case InvoiceStatus.Open.value:
                return InvoiceStatus.Open.label;
            case InvoiceStatus.OnApproval.value:
                return InvoiceStatus.OnApproval.label;
            case InvoiceStatus.Closed.value:
                return InvoiceStatus.Closed.label;
            case InvoiceStatus.Declined.value:
                return InvoiceStatus.Declined.label;
        }
    },

    options: () => [InvoiceStatus.Open, InvoiceStatus.OnApproval, InvoiceStatus.Closed, InvoiceStatus.Declined]
};

const MessageLink = {
    Campaign: {
        Marketplace: 'marketplace',
        Website: 'website',
        ArtsyMarketplace: 'artsyMarketplace',
        Custom: 'custom',
    },
    Email: {
        Marketplace: 0,
        Website: 1,
        ArtsyMarketplace: 2
    },

    // The marketplace name is passed in: Type.jsx is bundled into mkt SSR and collateral-engine, where theme/brand.js can't load.
    display: (type, marketplaceName) => {
        switch (type) {
            case MessageLink.Campaign.Marketplace:
            case MessageLink.Email.Marketplace:
                return marketplaceName;
            case MessageLink.Campaign.Website:
            case MessageLink.Email.Website:
                return 'Website';
            case MessageLink.Campaign.ArtsyMarketplace:
            case MessageLink.Email.ArtsyMarketplace:
                return 'Artsy Marketplace';
        }
    },

    optionsCampaign: (isArtsy, marketplaceName, labelProp = 'label') => {
        const options = [MessageLink.Campaign.Website, MessageLink.Campaign.Marketplace].map(value => ({ value, [labelProp]: MessageLink.display(value, marketplaceName) }))
        if (isArtsy) {
            options.push({ value: MessageLink.Campaign.ArtsyMarketplace, [labelProp]: MessageLink.display(MessageLink.Campaign.ArtsyMarketplace) });
        }
        return options;
    },

    optionsEmail: (isArtsy, marketplaceName, labelProp = 'label') => {
        const options = [MessageLink.Email.Website, MessageLink.Email.Marketplace].map(value => ({ value, [labelProp]: MessageLink.display(value, marketplaceName) }))
        if (isArtsy) {
            options.push({ value: MessageLink.Email.ArtsyMarketplace, [labelProp]: MessageLink.display(MessageLink.Email.ArtsyMarketplace) });
        }
        return options;
    }
};

const Metric = {
    Inches: { value: 0, label: 'Inches' },
    Centimeters: { value: 1, label: 'Centimeters' },
    Feet: { value: 2, label: 'Feet' },

    display: (type) => {
        switch (type) {
            case Metric.Inches.value:
                return Metric.Inches.label;
            case Metric.Centimeters.value:
                return Metric.Centimeters.label;
            case Metric.Feet.value:
                return Metric.Feet.label;
        }
    },

    options: () => [Metric.Centimeters, Metric.Inches, Metric.Feet],

    optionsLessFeet: () => [Metric.Centimeters, Metric.Inches],

    shortName: (type) => {
        switch (type) {
            case Metric.Inches.value:
                return 'in';
            case Metric.Centimeters.value:
                return 'cm';
            case Metric.Feet.value:
                return 'ft';
        }
    }
};

const Opt = {
    Resource: {
        Artist: 'artist',
        Exhibition: 'exhibition',
        Inventory: 'inventory',
        List: 'list',
        NewArrival: 'new arrival'
    },
    Url: {
        Marketplace: 'Marketplace',
        Website: 'Website'
    }
};

const Owner = {
    Mine: 0
};

const Ownership = {
    Consignment: { value: 1, label: 'Consignment' },
    Owned: { value: 2, label: 'Owned' },

    options: () => [Ownership.Consignment, Ownership.Owned]
};

const SaleStatus = {
    None: { value: 0, label: '' },
    OnApproval: { value: 1, label: 'On Approval' },
    OnOpenInvoice: { value: 2, label: 'On Open Invoice' },
    Sold: { value: 3, label: 'Sold' },

    display: (value) => {
        switch (value) {
            case SaleStatus.OnApproval.value:
                return SaleStatus.OnApproval.label;
            case SaleStatus.OnOpenInvoice.value:
                return SaleStatus.OnOpenInvoice.label;
            case SaleStatus.Sold.value:
                return SaleStatus.Sold.label;
            default:
                return null;
        }
    }
};

const Quicklist = {
    List: { value: 0, label: 'List' },
    Exhibition: { value: 1, label: 'Exhibition' },
    AdHoc: { value: 2 },
    PrivateExhibition: { value: 3, label: 'Private Exhibition' },
    PrivateView: { value: 10, label: 'Private View' },

    options: () => [Quicklist.List, Quicklist.Exhibition, Quicklist.PrivateExhibition]
};

const Recipient = {
    Contact: 0,
    Staff: 1,
    Artist: 2
};

const ShareResource = {
    Invoice: 'Invoice',
    Exhibition: 'Exhibition'
};

const SocialPlatform = {
    Instagram: { value: 0, label: 'Instagram' },
    Facebook: { value: 1, label: 'Facebook' },
    Twitter: { value: 2, label: 'Twitter/X' },
    Pinterest: { value: 3, label: 'Pinterest' },
    TikTok: { value: 4, label: 'TikTok' },
    LinkedIn: { value: 5, label: 'LinkedIn' },
    Bluesky: { value: 6, label: 'Bluesky' },
    WhatsApp: { value: 7, label: 'WhatsApp' },

    options: () => [
        SocialPlatform.Instagram,
        SocialPlatform.Facebook,
        SocialPlatform.Bluesky,
        SocialPlatform.Twitter,
        SocialPlatform.Pinterest,
        SocialPlatform.TikTok,
        SocialPlatform.LinkedIn,
        SocialPlatform.WhatsApp
    ],

    prefix: (type) => {
        switch (type) {
            case SocialPlatform.Instagram:
                return 'https://www.instagram.com/';
            case SocialPlatform.Facebook:
                return 'https://www.facebook.com/@';
            case SocialPlatform.Twitter:
                return 'https://twitter.com/@';
            case SocialPlatform.Pinterest:
                return 'https://www.pinterest.com/';
            case SocialPlatform.TikTok:
                return 'https://www.tiktok.com/@';
            case SocialPlatform.LinkedIn:
                return 'https://www.linkedin.com/in/';
            case SocialPlatform.Bluesky:
                return 'https://bsky.app/profile/';
            case SocialPlatform.WhatsApp:
                return 'https://wa.me/';
        }
    }
};

const Status = {
    All: { label: 'All' },
    Active: { value: 0, label: 'Active' },
    Inactive: { value: 1, label: 'Inactive' },

    options: () => [Status.All, Status.Active, Status.Inactive]
};

const Subscription = {
    AddOn: {
        Sales: 0
    },

    Campaign: {
        Tier: {
            None: 0,
            TwentyFiveThousand: 1,
            FiftyThousand: 2,
            OneHundredThousand: 3,
            OneHundredAndFiftyThousand: 4,
            TwoHundredThousand: 5,
            ThreeHundredThousand: 6,
            FourHundredThousand: 7,
            FiveHundredThousand: 8,
            TenThousand: 9
        }
    },

    Product: {
        Manager: 'Manager',
        Marketplace: 'Marketplace',
        Website: 'Website',

        getValue: (productType) => {
            switch (productType) {
                case Subscription.Product.Manager:
                    return 0;
                case Subscription.Product.Website:
                    return 1;
            }
        }
    },

    Tier: {
        // Legacy ArtCloud
        Basic: 'Basic',
        Free: 'Free',
        Pro: 'Pro',
        ProPlus: 'ProPlus',

        // 202508
        Essential_202508: 'Essential',
        Professional_202508: 'Professional',
        Expert_202508: 'Expert',

        // 202602
        Basic_202602: 'Basic_202602',
        Pro_202602: 'Pro_202602',
        ProPlus_202602: 'ProPlus_202602',

        getDisplay: (tierType) => {
            switch (tierType) {
                case Subscription.Tier.Basic_202602:
                    return "Basic";
                case Subscription.Tier.Pro_202602:
                    return "Pro";
                case Subscription.Tier.ProPlus:
                case Subscription.Tier.ProPlus_202602:
                    return "Pro Plus";
                default:
                    return tierType;
            }
        },

        getType: (tierValue) => {
            switch (tierValue) {
                case 1:
                    return Subscription.Tier.Basic;
                case 2:
                    return Subscription.Tier.Pro;
                case 3:
                    return Subscription.Tier.ProPlus;
                case 4:
                    return Subscription.Tier.Essential_202508;
                case 5:
                    return Subscription.Tier.Professional_202508;
                case 6:
                    return Subscription.Tier.Expert_202508;
                case 7:
                    return Subscription.Tier.Basic_202602;
                case 8:
                    return Subscription.Tier.Pro_202602;
                case 9:
                    return Subscription.Tier.ProPlus_202602;
                default:
                    return Subscription.Tier.Free;
            }
        },

        getValue: (tierType) => {
            switch (tierType) {
                case Subscription.Tier.Basic:
                    return 1;
                case Subscription.Tier.Pro:
                    return 2;
                case Subscription.Tier.ProPlus:
                    return 3;
                case Subscription.Tier.Essential_202508:
                    return 4;
                case Subscription.Tier.Professional_202508:
                    return 5;
                case Subscription.Tier.Expert_202508:
                    return 6;
                case Subscription.Tier.Basic_202602:
                    return 7;
                case Subscription.Tier.Pro_202602:
                    return 8;
                case Subscription.Tier.ProPlus_202602:
                    return 9;
                default:
                    return 0;
            }
        },

        isAllowable: (requiredTier, currentTier, product, isArtist) => {
            if (requiredTier == undefined) {
                return true;
            }
            switch (Subscription.Tier.getType(currentTier)) {
                case Subscription.Tier.Basic:
                case Subscription.Tier.Pro:
                case Subscription.Tier.ProPlus:
                    if (isArtist && product == Subscription.Product.Website) {
                        return currentTier >= Subscription.Tier.getValue(requiredTier.current);
                    }
                    return currentTier >= Subscription.Tier.getValue(requiredTier.legacy);
                default:
                    return currentTier >= Subscription.Tier.getValue(requiredTier.current);
            }
        }
    },

    User: {
        Artist: 'Artist',
        Collector: "Collector",
        Gallery: "Gallery",

        getType: (userValue) => {
            switch (userValue) {
                case 2:
                    return Subscription.User.Artist;
                case 1:
                case 3:
                    return Subscription.User.Gallery;
                case 6:
                    return Subscription.User.Collector;
            }
        },

        getValue: (userType) => {
            switch (userType) {
                case Subscription.User.Artist:
                    return 2;
                case Subscription.User.Collector:
                    return 6;
                case Subscription.User.Gallery:
                    return 3;
            }
        }
    }
};
Subscription.AddOn._price = {
    annual: {
        [Subscription.AddOn.Sales]: 756
    },
    monthly: {
        [Subscription.AddOn.Sales]: 69
    }
};
Subscription.AddOn.getPrice = (addOnType, isAnnual) => {
    switch (addOnType) {
        case Subscription.AddOn.Sales:
            if (isAnnual) {
                return Subscription.AddOn._price.annual[addOnType];
            }
            return Subscription.AddOn._price.monthly[addOnType];
    }
};
Subscription.Campaign.Tier._price = {
    annual: {
        [Subscription.Campaign.Tier.None]: 0,
        [Subscription.Campaign.Tier.TwentyFiveThousand]: 270,
        [Subscription.Campaign.Tier.FiftyThousand]: 540,
        [Subscription.Campaign.Tier.OneHundredThousand]: 810,
        [Subscription.Campaign.Tier.OneHundredAndFiftyThousand]: 1080,
        [Subscription.Campaign.Tier.TwoHundredThousand]: 1350,
        [Subscription.Campaign.Tier.ThreeHundredThousand]: 1944,
        [Subscription.Campaign.Tier.FourHundredThousand]: 2484,
        [Subscription.Campaign.Tier.FiveHundredThousand]: 2700
    },
    monthly: {
        [Subscription.Campaign.Tier.None]: 0,
        [Subscription.Campaign.Tier.TwentyFiveThousand]: 25,
        [Subscription.Campaign.Tier.FiftyThousand]: 50,
        [Subscription.Campaign.Tier.OneHundredThousand]: 75,
        [Subscription.Campaign.Tier.OneHundredAndFiftyThousand]: 100,
        [Subscription.Campaign.Tier.TwoHundredThousand]: 125,
        [Subscription.Campaign.Tier.ThreeHundredThousand]: 180,
        [Subscription.Campaign.Tier.FourHundredThousand]: 230,
        [Subscription.Campaign.Tier.FiveHundredThousand]: 250
    }
};
Subscription.Campaign.Tier._price202508 = {
    annual: {
        [Subscription.Campaign.Tier.None]: 0,
        [Subscription.Campaign.Tier.TenThousand]: 327,
        [Subscription.Campaign.Tier.TwentyFiveThousand]: 655,
        [Subscription.Campaign.Tier.FiftyThousand]: 742,
        [Subscription.Campaign.Tier.OneHundredThousand]: 1069,
        [Subscription.Campaign.Tier.OneHundredAndFiftyThousand]: 1309,
        [Subscription.Campaign.Tier.TwoHundredThousand]: 1440,
        [Subscription.Campaign.Tier.ThreeHundredThousand]: 2880,
        [Subscription.Campaign.Tier.FourHundredThousand]: 4320,
        [Subscription.Campaign.Tier.FiveHundredThousand]: 5760
    },
    monthly: {
        [Subscription.Campaign.Tier.None]: 0,
        [Subscription.Campaign.Tier.TenThousand]: 30,
        [Subscription.Campaign.Tier.TwentyFiveThousand]: 60,
        [Subscription.Campaign.Tier.FiftyThousand]: 68,
        [Subscription.Campaign.Tier.OneHundredThousand]: 98,
        [Subscription.Campaign.Tier.OneHundredAndFiftyThousand]: 120,
        [Subscription.Campaign.Tier.TwoHundredThousand]: 132,
        [Subscription.Campaign.Tier.ThreeHundredThousand]: 264,
        [Subscription.Campaign.Tier.FourHundredThousand]: 396,
        [Subscription.Campaign.Tier.FiveHundredThousand]: 528
    }
};
Subscription.Campaign.Tier.getPrice = (campaignTierType, managerTier, isAnnual) => {
    switch (managerTier) {
        case Subscription.Tier.Expert_202508:
        case Subscription.Tier.Professional_202508:
            if (isAnnual) {
                return Subscription.Campaign.Tier._price202508.annual[campaignTierType];
            }
            return Subscription.Campaign.Tier._price202508.monthly[campaignTierType];
        case Subscription.Tier.Basic_202602:
        case Subscription.Tier.Pro_202602:
        case Subscription.Tier.ProPlus_202602:
            if (isAnnual) {
                return Subscription.Campaign.Tier._price.annual[campaignTierType];
            }
            return Subscription.Campaign.Tier._price.monthly[campaignTierType];
        case Subscription.Tier.ProPlus:
            return Subscription.Campaign.Tier._price.monthly[campaignTierType];
    }
};
Subscription.Campaign.Tier.options = (managerTier, isAnnual, includeNoneOption) => {
    let options = [];
    let period = isAnnual ? 'year' : 'month';
    switch (managerTier) {
        case Subscription.Tier.ProPlus:
            period = 'month';
        // Intentional fallthrough
        case Subscription.Tier.ProPlus_202602:
            options.push({ value: Subscription.Campaign.Tier.None, label: '10,000 (Included with Pro Plus)' });
            break;
        case Subscription.Tier.Expert_202508:
        case Subscription.Tier.Professional_202508:
            if (includeNoneOption != false) {
                options.push({ value: Subscription.Campaign.Tier.None, label: `None` })
            }
            options.push({ value: Subscription.Campaign.Tier.TenThousand, label: `10,000 (+ $${Artcloud.format.withThousandsSeparator(Subscription.Campaign.Tier.getPrice(Subscription.Campaign.Tier.TenThousand, managerTier, isAnnual))} /${period})` })
            break;
        case Subscription.Tier.Basic_202602:
        case Subscription.Tier.Pro_202602:
            return options;
        default:
            return [{ value: Subscription.Campaign.Tier.None, label: `None` }];
    }
    options.push(
        {
            value: Subscription.Campaign.Tier.TwentyFiveThousand,
            label: `25,000 (+ $${Artcloud.format.withThousandsSeparator(Subscription.Campaign.Tier.getPrice(Subscription.Campaign.Tier.TwentyFiveThousand, managerTier, isAnnual))} /${period})`
        },
        {
            value: Subscription.Campaign.Tier.FiftyThousand,
            label: `50,000 (+ $${Artcloud.format.withThousandsSeparator(Subscription.Campaign.Tier.getPrice(Subscription.Campaign.Tier.FiftyThousand, managerTier, isAnnual))} /${period})`
        },
        {
            value: Subscription.Campaign.Tier.OneHundredThousand,
            label: `100,000 (+ $${Artcloud.format.withThousandsSeparator(Subscription.Campaign.Tier.getPrice(Subscription.Campaign.Tier.OneHundredThousand, managerTier, isAnnual))} /${period})`
        },
        {
            value: Subscription.Campaign.Tier.OneHundredAndFiftyThousand,
            label: `150,000 (+ $${Artcloud.format.withThousandsSeparator(Subscription.Campaign.Tier.getPrice(Subscription.Campaign.Tier.OneHundredAndFiftyThousand, managerTier, isAnnual))} /${period})`
        },
        {
            value: Subscription.Campaign.Tier.TwoHundredThousand,
            label: `200,000 (+ $${Artcloud.format.withThousandsSeparator(Subscription.Campaign.Tier.getPrice(Subscription.Campaign.Tier.TwoHundredThousand, managerTier, isAnnual))} /${period})`
        },
        {
            value: Subscription.Campaign.Tier.ThreeHundredThousand,
            label: `300,000 (+ $${Artcloud.format.withThousandsSeparator(Subscription.Campaign.Tier.getPrice(Subscription.Campaign.Tier.ThreeHundredThousand, managerTier, isAnnual))} /${period})`
        },
        {
            value: Subscription.Campaign.Tier.FourHundredThousand,
            label: `400,000 (+ $${Artcloud.format.withThousandsSeparator(Subscription.Campaign.Tier.getPrice(Subscription.Campaign.Tier.FourHundredThousand, managerTier, isAnnual))} /${period})`
        },
        {
            value: Subscription.Campaign.Tier.FiveHundredThousand,
            label: `500,000 (+ $${Artcloud.format.withThousandsSeparator(Subscription.Campaign.Tier.getPrice(Subscription.Campaign.Tier.FiveHundredThousand, managerTier, isAnnual))} /${period})`
        }
    )
    return options;
};

Subscription.UserSubscriptionTier = {
    ArtistManagerBasic: `${Subscription.User.Artist}${Subscription.Product.Manager}${Subscription.Tier.Basic}`,
    ArtistManagerFree: `${Subscription.User.Artist}${Subscription.Product.Manager}${Subscription.Tier.Free}`,
    ArtistManagerPro: `${Subscription.User.Artist}${Subscription.Product.Manager}${Subscription.Tier.Pro}`,
    ArtistManagerProPlus: `${Subscription.User.Artist}${Subscription.Product.Manager}${Subscription.Tier.ProPlus}`,
    ArtistWebsiteBasic: `${Subscription.User.Artist}${Subscription.Product.Website}${Subscription.Tier.Basic}`,
    ArtistWebsitePro: `${Subscription.User.Artist}${Subscription.Product.Website}${Subscription.Tier.Pro}`,
    ArtistWebsiteProPlus: `${Subscription.User.Artist}${Subscription.Product.Website}${Subscription.Tier.ProPlus}`,
    CollectorManagerBasic: `${Subscription.User.Collector}${Subscription.Product.Manager}${Subscription.Tier.Basic}`,
    CollectorManagerPro: `${Subscription.User.Collector}${Subscription.Product.Manager}${Subscription.Tier.Pro}`,

    // Legacy ArtCloud
    GalleryManagerBasic: `${Subscription.User.Gallery}${Subscription.Product.Manager}${Subscription.Tier.Basic}`,
    GalleryManagerFree: `${Subscription.User.Gallery}${Subscription.Product.Manager}${Subscription.Tier.Free}`,
    GalleryManagerPro: `${Subscription.User.Gallery}${Subscription.Product.Manager}${Subscription.Tier.Pro}`,
    GalleryManagerProPlus: `${Subscription.User.Gallery}${Subscription.Product.Manager}${Subscription.Tier.ProPlus}`,
    GalleryWebsiteBasic: `${Subscription.User.Gallery}${Subscription.Product.Website}${Subscription.Tier.Basic}`,
    GalleryWebsitePro: `${Subscription.User.Gallery}${Subscription.Product.Website}${Subscription.Tier.Pro}`,
    GalleryWebsiteProPlus: `${Subscription.User.Gallery}${Subscription.Product.Website}${Subscription.Tier.ProPlus}`,

    // 2025
    GalleryManagerEssential_202508: `${Subscription.User.Gallery}${Subscription.Product.Manager}${Subscription.Tier.Essential_202508}`,
    GalleryManagerExpert_202508: `${Subscription.User.Gallery}${Subscription.Product.Manager}${Subscription.Tier.Expert_202508}`,
    GalleryManagerProfessional_202508: `${Subscription.User.Gallery}${Subscription.Product.Manager}${Subscription.Tier.Professional_202508}`,
    GalleryWebsiteEssential_202508: `${Subscription.User.Gallery}${Subscription.Product.Website}${Subscription.Tier.Essential_202508}`,
    GalleryWebsiteExpert_202508: `${Subscription.User.Gallery}${Subscription.Product.Website}${Subscription.Tier.Expert_202508}`,
    GalleryWebsiteProfessional_202508: `${Subscription.User.Gallery}${Subscription.Product.Website}${Subscription.Tier.Professional_202508}`,

    // 2026
    ArtistManagerBasic_202602: `${Subscription.User.Artist}${Subscription.Product.Manager}${Subscription.Tier.Basic_202602}`,
    ArtistManagerPro_202602: `${Subscription.User.Artist}${Subscription.Product.Manager}${Subscription.Tier.Pro_202602}`,
    ArtistManagerProPlus_202602: `${Subscription.User.Artist}${Subscription.Product.Manager}${Subscription.Tier.ProPlus_202602}`,

    calculateSubtotal: (staffCount, userType, managerTier, websiteTier, isAnnual, promotionCode) => {
        let userSubscriptionTier = `${userType}${Subscription.Product.Manager}${managerTier}`;
        let _subtotal = staffCount * (Subscription.UserSubscriptionTier.getPrice(userSubscriptionTier, isAnnual) || 0);
        if (websiteTier) {
            userSubscriptionTier = `${userType}${Subscription.Product.Website}${websiteTier}`;
            _subtotal += (Subscription.UserSubscriptionTier.getPrice(userSubscriptionTier, isAnnual) || 0);
        }
        if (promotionCode) {
            if (promotionCode.AmountOff) {
                _subtotal -= (promotionCode.AmountOff / 100.0);
            } else if (promotionCode.PercentOff) {
                _subtotal *= ((100.0 - promotionCode.PercentOff) / 100.0);
            }
        }
        return _subtotal;
    }
};
Subscription.UserSubscriptionTier._price = {
    annual: {
        [Subscription.UserSubscriptionTier.ArtistManagerBasic]: 313,
        [Subscription.UserSubscriptionTier.ArtistManagerFree]: 0,
        [Subscription.UserSubscriptionTier.ArtistManagerPro]: 853,
        [Subscription.UserSubscriptionTier.ArtistManagerProPlus]: 1609,
        [Subscription.UserSubscriptionTier.ArtistWebsiteBasic]: 205,
        [Subscription.UserSubscriptionTier.ArtistWebsitePro]: 529,
        [Subscription.UserSubscriptionTier.ArtistWebsiteProPlus]: 1069,
        [Subscription.UserSubscriptionTier.ArtistManagerBasic_202602]: 313,
        [Subscription.UserSubscriptionTier.ArtistManagerPro_202602]: 961,
        [Subscription.UserSubscriptionTier.ArtistManagerProPlus_202602]: 1609,
        [Subscription.UserSubscriptionTier.CollectorManagerBasic]: 0,
        [Subscription.UserSubscriptionTier.CollectorManagerPro]: 205,
        [Subscription.UserSubscriptionTier.GalleryManagerBasic]: 853,
        [Subscription.UserSubscriptionTier.GalleryManagerFree]: 0,
        [Subscription.UserSubscriptionTier.GalleryManagerPro]: 1609,
        [Subscription.UserSubscriptionTier.GalleryManagerProPlus]: 3229,
        [Subscription.UserSubscriptionTier.GalleryWebsiteBasic]: 529,
        [Subscription.UserSubscriptionTier.GalleryWebsitePro]: 1069,
        [Subscription.UserSubscriptionTier.GalleryWebsiteProPlus]: 1609,
        [Subscription.UserSubscriptionTier.GalleryManagerEssential_202508]: 1069,
        [Subscription.UserSubscriptionTier.GalleryManagerExpert_202508]: 2100,
        [Subscription.UserSubscriptionTier.GalleryManagerProfessional_202508]: 1440,
        [Subscription.UserSubscriptionTier.GalleryWebsiteEssential_202508]: 840,
        [Subscription.UserSubscriptionTier.GalleryWebsiteExpert_202508]: 3300,
        [Subscription.UserSubscriptionTier.GalleryWebsiteProfessional_202508]: 1896
    },
    monthly: {
        [Subscription.UserSubscriptionTier.ArtistManagerBasic]: 29,
        [Subscription.UserSubscriptionTier.ArtistManagerFree]: 0,
        [Subscription.UserSubscriptionTier.ArtistManagerPro]: 79,
        [Subscription.UserSubscriptionTier.ArtistManagerProPlus]: 149,
        [Subscription.UserSubscriptionTier.ArtistWebsiteBasic]: 19,
        [Subscription.UserSubscriptionTier.ArtistWebsitePro]: 49,
        [Subscription.UserSubscriptionTier.ArtistWebsiteProPlus]: 99,
        [Subscription.UserSubscriptionTier.ArtistManagerBasic_202602]: 29,
        [Subscription.UserSubscriptionTier.ArtistManagerPro_202602]: 89,
        [Subscription.UserSubscriptionTier.ArtistManagerProPlus_202602]: 149,
        [Subscription.UserSubscriptionTier.CollectorManagerBasic]: 0,
        [Subscription.UserSubscriptionTier.CollectorManagerPro]: 19,
        [Subscription.UserSubscriptionTier.GalleryManagerBasic]: 79,
        [Subscription.UserSubscriptionTier.GalleryManagerFree]: 0,
        [Subscription.UserSubscriptionTier.GalleryManagerPro]: 149,
        [Subscription.UserSubscriptionTier.GalleryManagerProPlus]: 299,
        [Subscription.UserSubscriptionTier.GalleryWebsiteBasic]: 49,
        [Subscription.UserSubscriptionTier.GalleryWebsitePro]: 99,
        [Subscription.UserSubscriptionTier.GalleryWebsiteProPlus]: 149,
        [Subscription.UserSubscriptionTier.GalleryManagerEssential_202508]: 98,
        [Subscription.UserSubscriptionTier.GalleryManagerExpert_202508]: 193,
        [Subscription.UserSubscriptionTier.GalleryManagerProfessional_202508]: 132,
        [Subscription.UserSubscriptionTier.GalleryWebsiteEssential_202508]: 77,
        [Subscription.UserSubscriptionTier.GalleryWebsiteExpert_202508]: 303,
        [Subscription.UserSubscriptionTier.GalleryWebsiteProfessional_202508]: 174
    }
};
Subscription.UserSubscriptionTier.getPrice = (userSubscriptionTierType, isAnnual) => {
    if (isAnnual) {
        return Subscription.UserSubscriptionTier._price.annual[userSubscriptionTierType];
    }
    return Subscription.UserSubscriptionTier._price.monthly[userSubscriptionTierType];
};

const Tag = {
    ArtistTag: 0,
    Art: 1,
    ContactInterest: 2,
    Contact: 3,
    ArtLocation: 4,
    Artist: 5,
    Medium: 6,
    ContactOrigin: 7,
    List: 8,
    Blog: 9,
    Genre: 10,
    Invoice: 11,
    InvoiceOrigin: 12
};

const Tax = {
    Sales: { value: 0, label: 'Sales' },
    GST: { value: 1, label: 'GST' },
    VAT: { value: 3, label: 'VAT' },
    None: { value: 2, label: 'None' },

    options: () => [Tax.Sales, Tax.GST, Tax.VAT, Tax.None],

    basisOptions: () => [
        { value: 'sales', label: 'Sales', taxType: Tax.Sales.value, inclusive: false },
        { value: 'gst-incl', label: 'GST incl.', taxType: Tax.GST.value, inclusive: true },
        { value: 'gst-excl', label: 'GST excl.', taxType: Tax.GST.value, inclusive: false },
        { value: 'vat-incl', label: 'VAT incl.', taxType: Tax.VAT.value, inclusive: true },
        { value: 'vat-excl', label: 'VAT excl.', taxType: Tax.VAT.value, inclusive: false },
        { value: 'none', label: 'None', taxType: Tax.None.value, inclusive: false }
    ],

    basisValue: (taxType, inclusive) =>
        taxType == Tax.VAT.value ? (inclusive ? 'vat-incl' : 'vat-excl')
            : taxType == Tax.GST.value ? (inclusive ? 'gst-incl' : 'gst-excl')
                : taxType == Tax.None.value ? 'none'
                    : 'sales',

    basisFrom: value => Tax.basisOptions().find(o => o.value == value) || Tax.basisOptions()[0]
};

const Theme = {
    AccountType: {
        Gallery: 1,
        Artist: 2
    }
};

const TimeZone = {
    EasternStandardTime: { label: '(UTC-05:00) Eastern Time (US & Canada)', value: 'Eastern Standard Time' },

    options: () => [
        { label: '(UTC-12:00) International Date Line West', value: 'Dateline Standard Time' },
        { label: '(UTC-11:00) Coordinated Universal Time-11', value: 'UTC-11' },
        { label: '(UTC-10:00) Aleutian Islands', value: 'Aleutian Standard Time' },
        { label: '(UTC-10:00) Hawaii', value: 'Hawaiian Standard Time' },
        { label: '(UTC-09:30) Marquesas Islands', value: 'Marquesas Standard Time' },
        { label: '(UTC-09:00) Alaska', value: 'Alaskan Standard Time' },
        { label: '(UTC-09:00) Coordinated Universal Time-09', value: 'UTC-09' },
        { label: '(UTC-08:00) Baja California', value: 'Pacific Standard Time (Mexico)' },
        { label: '(UTC-08:00) Coordinated Universal Time-08', value: 'UTC-08' },
        { label: '(UTC-08:00) Pacific Time (US & Canada)', value: 'Pacific Standard Time' },
        { label: '(UTC-07:00) Arizona', value: 'US Mountain Standard Time' },
        { label: '(UTC-07:00) Chihuahua, La Paz, Mazatlan', value: 'Mountain Standard Time (Mexico)' },
        { label: '(UTC-07:00) Mountain Time (US & Canada)', value: 'Mountain Standard Time' },
        { label: '(UTC-06:00) Central America', value: 'Central America Standard Time' },
        { label: '(UTC-06:00) Central Time (US & Canada)', value: 'Central Standard Time' },
        { label: '(UTC-06:00) Easter Island', value: 'Easter Island Standard Time' },
        { label: '(UTC-06:00) Guadalajara, Mexico City, Monterrey', value: 'Central Standard Time (Mexico)' },
        { label: '(UTC-06:00) Saskatchewan', value: 'Canada Central Standard Time' },
        { label: '(UTC-05:00) Bogota, Lima, Quito, Rio Branco', value: 'SA Pacific Standard Time' },
        { label: '(UTC-05:00) Chetumal', value: 'Eastern Standard Time (Mexico)' },
        TimeZone.EasternStandardTime,
        { label: '(UTC-05:00) Haiti', value: 'Haiti Standard Time' },
        { label: '(UTC-05:00) Havana', value: 'Cuba Standard Time' },
        { label: '(UTC-05:00) Indiana (East)', value: 'US Eastern Standard Time' },
        { label: '(UTC-05:00) Turks and Caicos', value: 'Turks And Caicos Standard Time' },
        { label: '(UTC-04:00) Asuncion', value: 'Paraguay Standard Time' },
        { label: '(UTC-04:00) Atlantic Time (Canada)', value: 'Atlantic Standard Time' },
        { label: '(UTC-04:00) Caracas', value: 'Venezuela Standard Time' },
        { label: '(UTC-04:00) Cuiaba', value: 'Central Brazilian Standard Time' },
        { label: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan', value: 'SA Western Standard Time' },
        { label: '(UTC-04:00) Santiago', value: 'Pacific SA Standard Time' },
        { label: '(UTC-03:30) Newfoundland', value: 'Newfoundland Standard Time' },
        { label: '(UTC-03:00) Araguaina', value: 'Tocantins Standard Time' },
        { label: '(UTC-03:00) Brasilia', value: 'E. South America Standard Time' },
        { label: '(UTC-03:00) Cayenne, Fortaleza', value: 'SA Eastern Standard Time' },
        { label: '(UTC-03:00) City of Buenos Aires', value: 'Argentina Standard Time' },
        { label: '(UTC-03:00) Greenland', value: 'Greenland Standard Time' },
        { label: '(UTC-03:00) Montevideo', value: 'Montevideo Standard Time' },
        { label: '(UTC-03:00) Punta Arenas', value: 'Magallanes Standard Time' },
        { label: '(UTC-03:00) Saint Pierre and Miquelon', value: 'Saint Pierre Standard Time' },
        { label: '(UTC-03:00) Salvador', value: 'Bahia Standard Time' },
        { label: '(UTC-02:00) Coordinated Universal Time-02', value: 'UTC-02' },
        { label: '(UTC-02:00) Mid-Atlantic - Old', value: 'Mid-Atlantic Standard Time' },
        { label: '(UTC-01:00) Azores', value: 'Azores Standard Time' },
        { label: '(UTC-01:00) Cabo Verde Is.', value: 'Cape Verde Standard Time' },
        { label: '(UTC) Coordinated Universal Time', value: 'UTC' },
        { label: '(UTC+00:00) Casablanca', value: 'Morocco Standard Time' },
        { label: '(UTC+00:00) Dublin, Edinburgh, Lisbon, London', value: 'GMT Standard Time' },
        { label: '(UTC+00:00) Monrovia, Reykjavik', value: 'Greenwich Standard Time' },
        { label: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna', value: 'W. Europe Standard Time' },
        { label: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague', value: 'Central Europe Standard Time' },
        { label: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris', value: 'Romance Standard Time' },
        { label: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb', value: 'Central European Standard Time' },
        { label: '(UTC+01:00) West Central Africa', value: 'W. Central Africa Standard Time' },
        { label: '(UTC+02:00) Amman', value: 'Jordan Standard Time' },
        { label: '(UTC+02:00) Athens, Bucharest', value: 'GTB Standard Time' },
        { label: '(UTC+02:00) Beirut', value: 'Middle East Standard Time' },
        { label: '(UTC+02:00) Cairo', value: 'Egypt Standard Time' },
        { label: '(UTC+02:00) Chisinau', value: 'E. Europe Standard Time' },
        { label: '(UTC+02:00) Damascus', value: 'Syria Standard Time' },
        { label: '(UTC+02:00) Gaza, Hebron', value: 'West Bank Standard Time' },
        { label: '(UTC+02:00) Harare, Pretoria', value: 'South Africa Standard Time' },
        { label: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius', value: 'FLE Standard Time' },
        { label: '(UTC+02:00) Jerusalem', value: 'Israel Standard Time' },
        { label: '(UTC+02:00) Kaliningrad', value: 'Kaliningrad Standard Time' },
        { label: '(UTC+02:00) Khartoum', value: 'Sudan Standard Time' },
        { label: '(UTC+02:00) Tripoli', value: 'Libya Standard Time' },
        { label: '(UTC+02:00) Windhoek', value: 'Namibia Standard Time' },
        { label: '(UTC+03:00) Baghdad', value: 'Arabic Standard Time' },
        { label: '(UTC+03:00) Istanbul', value: 'Turkey Standard Time' },
        { label: '(UTC+03:00) Kuwait, Riyadh', value: 'Arab Standard Time' },
        { label: '(UTC+03:00) Minsk', value: 'Belarus Standard Time' },
        { label: '(UTC+03:00) Moscow, St. Petersburg, Volgograd', value: 'Russian Standard Time' },
        { label: '(UTC+03:00) Nairobi', value: 'E. Africa Standard Time' },
        { label: '(UTC+03:30) Tehran', value: 'Iran Standard Time' },
        { label: '(UTC+04:00) Abu Dhabi, Muscat', value: 'Arabian Standard Time' },
        { label: '(UTC+04:00) Astrakhan, Ulyanovsk', value: 'Astrakhan Standard Time' },
        { label: '(UTC+04:00) Baku', value: 'Azerbaijan Standard Time' },
        { label: '(UTC+04:00) Izhevsk, Samara', value: 'Russia Time Zone 3' },
        { label: '(UTC+04:00) Port Louis', value: 'Mauritius Standard Time' },
        { label: '(UTC+04:00) Saratov', value: 'Saratov Standard Time' },
        { label: '(UTC+04:00) Tbilisi', value: 'Georgian Standard Time' },
        { label: '(UTC+04:00) Yerevan', value: 'Caucasus Standard Time' },
        { label: '(UTC+04:30) Kabul', value: 'Afghanistan Standard Time' },
        { label: '(UTC+05:00) Ashgabat, Tashkent', value: 'West Asia Standard Time' },
        { label: '(UTC+05:00) Ekaterinburg', value: 'Ekaterinburg Standard Time' },
        { label: '(UTC+05:00) Islamabad, Karachi', value: 'Pakistan Standard Time' },
        { label: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi', value: 'India Standard Time' },
        { label: '(UTC+05:30) Sri Jayawardenepura', value: 'Sri Lanka Standard Time' },
        { label: '(UTC+05:45) Kathmandu', value: 'Nepal Standard Time' },
        { label: '(UTC+06:00) Astana', value: 'Central Asia Standard Time' },
        { label: '(UTC+06:00) Dhaka', value: 'Bangladesh Standard Time' },
        { label: '(UTC+06:00) Omsk', value: 'Omsk Standard Time' },
        { label: '(UTC+06:30) Yangon (Rangoon)', value: 'Myanmar Standard Time' },
        { label: '(UTC+07:00) Bangkok, Hanoi, Jakarta', value: 'SE Asia Standard Time' },
        { label: '(UTC+07:00) Barnaul, Gorno-Altaysk', value: 'Altai Standard Time' },
        { label: '(UTC+07:00) Hovd', value: 'W. Mongolia Standard Time' },
        { label: '(UTC+07:00) Krasnoyarsk', value: 'North Asia Standard Time' },
        { label: '(UTC+07:00) Novosibirsk', value: 'N. Central Asia Standard Time' },
        { label: '(UTC+07:00) Tomsk', value: 'Tomsk Standard Time' },
        { label: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi', value: 'China Standard Time' },
        { label: '(UTC+08:00) Irkutsk', value: 'North Asia East Standard Time' },
        { label: '(UTC+08:00) Kuala Lumpur, Singapore', value: 'Singapore Standard Time' },
        { label: '(UTC+08:00) Perth', value: 'W. Australia Standard Time' },
        { label: '(UTC+08:00) Taipei', value: 'Taipei Standard Time' },
        { label: '(UTC+08:00) Ulaanbaatar', value: 'Ulaanbaatar Standard Time' },
        { label: '(UTC+08:30) Pyongyang', value: 'North Korea Standard Time' },
        { label: '(UTC+08:45) Eucla', value: 'Aus Central W. Standard Time' },
        { label: '(UTC+09:00) Chita', value: 'Transbaikal Standard Time' },
        { label: '(UTC+09:00) Osaka, Sapporo, Tokyo', value: 'Tokyo Standard Time' },
        { label: '(UTC+09:00) Seoul', value: 'Korea Standard Time' },
        { label: '(UTC+09:00) Yakutsk', value: 'Yakutsk Standard Time' },
        { label: '(UTC+09:30) Adelaide', value: 'Cen. Australia Standard Time' },
        { label: '(UTC+09:30) Darwin', value: 'AUS Central Standard Time' },
        { label: '(UTC+10:00) Brisbane', value: 'E. Australia Standard Time' },
        { label: '(UTC+10:00) Canberra, Melbourne, Sydney', value: 'AUS Eastern Standard Time' },
        { label: '(UTC+10:00) Guam, Port Moresby', value: 'West Pacific Standard Time' },
        { label: '(UTC+10:00) Hobart', value: 'Tasmania Standard Time' },
        { label: '(UTC+10:00) Vladivostok', value: 'Vladivostok Standard Time' },
        { label: '(UTC+10:30) Lord Howe Island', value: 'Lord Howe Standard Time' },
        { label: '(UTC+11:00) Bougainville Island', value: 'Bougainville Standard Time' },
        { label: '(UTC+11:00) Chokurdakh', value: 'Russia Time Zone 10' },
        { label: '(UTC+11:00) Magadan', value: 'Magadan Standard Time' },
        { label: '(UTC+11:00) Norfolk Island', value: 'Norfolk Standard Time' },
        { label: '(UTC+11:00) Sakhalin', value: 'Sakhalin Standard Time' },
        { label: '(UTC+11:00) Solomon Is., New Caledonia', value: 'Central Pacific Standard Time' },
        { label: '(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky', value: 'Russia Time Zone 11' },
        { label: '(UTC+12:00) Auckland, Wellington', value: 'New Zealand Standard Time' },
        { label: '(UTC+12:00) Coordinated Universal Time+12', value: 'UTC+12' },
        { label: '(UTC+12:00) Fiji', value: 'Fiji Standard Time' },
        { label: '(UTC+12:00) Petropavlovsk-Kamchatsky - Old', value: 'Kamchatka Standard Time' },
        { label: '(UTC+12:45) Chatham Islands', value: 'Chatham Islands Standard Time' },
        { label: '(UTC+13:00) Coordinated Universal Time+13', value: 'UTC+13' },
        { label: '(UTC+13:00) Nuku\'alofa', value: 'Tonga Standard Time' },
        { label: '(UTC+13:00) Samoa', value: 'Samoa Standard Time' },
        { label: '(UTC+14:00) Kiritimati Island', value: 'Line Islands Standard Time' }
    ]
};

const ToDoStatus = {
    Open: { value: 0, label: 'Open' },
    Overdue: { value: 1, label: 'Overdue' },
    Completed: { value: 2, label: 'Completed' },

    options: () => [ToDoStatus.Open, ToDoStatus.Overdue, ToDoStatus.Completed]
};

const Trial = {
    None: 0,
    Trialing: 1,
    Expired: 2,
    Subscribed: 3,
    Delinquent: 4
};

const User = {
    Artist: { value: 2, label: 'Artist' },
    Gallery: { value: 3, label: 'Gallery' },
    Staff: { value: 5, label: 'Staff' },
    Collector: { value: 6, label: 'Collector' },

    options: () => [User.Artist, User.Gallery, User.Collector]
};

const ViewMode = {
    List: 0,
    Alternate: 1
};

const Visibility = {
    Visible: 0,
    Hidden: 1
}

const WebsiteContent = {
    Blog: 0,
    Media: 1
};

const WebsitePage = {
    Custom: { value: 0, label: 'Custom' },
    Inventory: { value: 1, label: 'Inventory' },
    Artists: { value: 2, label: 'Artists' },
    Exhibitions: { value: 3, label: 'Exhibitions' },
    Contact: { value: 5, label: 'Contact' },
    ExternalLink: { value: 6, label: 'External Link' },
    Home: { value: 7, label: 'Home' },
    PrivateViews: { value: 10, label: 'Private Views' },

    options: () => [
        WebsitePage.Custom,
        WebsitePage.Inventory,
        WebsitePage.Artists,
        WebsitePage.Exhibitions,
        WebsitePage.Contact,
        WebsitePage.ExternalLink
    ]
};

const WeightMetric = {
    Pounds: { value: 0, label: 'Pounds' },
    Kilograms: { value: 1, label: 'Kilograms' },
    Grams: { value: 2, label: 'Grams' },

    options: () => [WeightMetric.Pounds, WeightMetric.Kilograms, WeightMetric.Grams]
}

const YesNo = {
    No: { value: 0, label: 'No' },
    Yes: { value: 1, label: 'Yes' },

    options: () => [YesNo.No, YesNo.Yes]
};

export {
    AcceptedPayment,
    Account,
    ActiveStatus,
    Activity,
    ActivityFilter,
    ActivityStatus,
    Address,
    AdminEmail,
    AdminUser,
    AnalyticsDateRange,
    AnalyticsSource,
    Audience,
    Batch,
    BatchStatus,
    BillingPermission,
    Campaign,
    CampaignAudienceRetarget,
    CampaignResults,
    CollateralExport,
    Composition,
    Consignment,
    isSendable,
    ConsignmentCost,
    Consigner,
    Currency,
    CurrencySymbolPlacement,
    DateFormat,
    Discount,
    Edition,
    Email,
    Export,
    ExportStatus,
    Gate,
    ImportStatus,
    Inventory,
    InviteStage,
    Invoice,
    InvoiceItem,
    InvoiceStatus,
    MessageLink,
    Metric,
    Opt,
    Owner,
    Ownership,
    Quicklist,
    Recipient,
    SaleStatus,
    ShareResource,
    SocialPlatform,
    Status,
    Subscription,
    Tag,
    Tax,
    Theme,
    TimeZone,
    ToDoStatus,
    Trial,
    User,
    ViewMode,
    Visibility,
    WebsiteContent,
    WebsitePage,
    WeightMetric,
    YesNo
}
